import type { Entity } from "@backstage/catalog-model";
import type { ExtensionDefinition } from "@backstage/frontend-plugin-api";
import { EntityCardBlueprint } from "@backstage/plugin-catalog-react/alpha";
import { GITHUB_PROJECT_SLUG_ANNOTATION } from "@internal/backstage-plugin-github-common";

/**
 * True when the entity is backed by a GitHub repository, i.e. it carries a
 * `github.com/project-slug` annotation. Entities without one have no releases
 * to show, so the card is hidden entirely rather than rendering an error.
 */
export const isGithubReleasesAvailable = (entity: Entity): boolean =>
    Boolean(entity.metadata.annotations?.[GITHUB_PROJECT_SLUG_ANNOTATION]);

/**
 * Entity card that surfaces one GitHub release at a time — its notes rendered
 * as markdown — with a picker in the header for switching to older ones.
 */
export const githubReleasesCard: ExtensionDefinition = EntityCardBlueprint.make(
    {
        name: "releases",
        params: {
            filter: isGithubReleasesAvailable,
            loader: () =>
                import("@internal/backstage-plugin-github-react").then(m => (
                    <m.ReleasesCard />
                )),
        },
    }
);
